"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lang_1 = require("../util/lang");
exports.pkgId = lang_1.randomId();
exports.pkgVersion = process.env.PKG_VERSION;
exports.default = {
    pkgId: exports.pkgId,
    pkgVersion: exports.pkgVersion
};
